import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/api";
import axiosPrivate from "../../services/axios/axiosPrivate";

export const fetchSearchData = createAsyncThunk('searchData/fetchSearchData',
  async ({type, keyword, page = 0 }, { rejectWithValue }) => {
    try {
      const url = `${api.searchCandidateAndEmployee}${type}?keyword=${keyword}&page=${page}&size=10&sortBy=creationDate&direction=desc`;
      const response = await axiosPrivate.get(url);
      return response.data.data;
    } catch(error) {
      return rejectWithValue(error?.response?.data?.message || "Unable to connect to server");
    }
  })

const searchDataSlice = createSlice({
  name: 'SearchData',
  initialState: {
    SearchDataList: [],
    status: 'idle',
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builders) => {
    builders.
      addCase(fetchSearchData.pending,
        (state) => {
          state.status = 'loading';
          state.loading = true;
          state.error = null;
        })
      .addCase(fetchSearchData.fulfilled,
        (state, action) => {
          state.status = 'succeeded';
          state.loading = false;
          state.SearchDataList = action.payload;
        })
      .addCase(fetchSearchData.rejected,
        (state, action) => {
          state.status = 'failed';
          state.loading = false;
          state.error = action.payload;
        }
      )
  }
})

export default searchDataSlice.reducer;